module.exports = __webpack_public_path__ + "static/img/CY.078d95d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/countryFlag/CY.svg
// module id = Dlm7
// module chunks = 66